import React from "react";
import { Check, X } from "lucide-react";
import { motion } from "framer-motion";

const oldStack = [
  "Fragmented SDR + agencies + ads tools",
  "Cold lists, generic copy, no real qualification",
  "Raw leads dumped on AEs to chase",
  "Long ramps, turnover, manager overhead",
  "Reporting stitched across 5 dashboards",
  "Paying for activity, not outcomes",
];

const ours = [
  "Single end-to-end engine, fully managed",
  "Deep ICP + intent + BANT before any handoff",
  "Only pre-qualified meetings hit the calendar",
  "Zero hiring, zero ramp, zero churn",
  "One source of truth on every meeting",
  "Performance-based: we win when you win",
];

export default function Comparison() {
  return (
    <section
      id="comparison"
      data-testid="comparison-section"
      className="relative py-24 md:py-36 bg-[#0B0D12]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-[#FF4500] mb-4">
            Old stack vs. prospectivly
          </p>
          <h2 className="font-editorial font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
            Stop renting <span className="italic">five</span> tools.
            <br />
            Start running <span className="italic">one</span> engine.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Old stack */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            data-testid="comparison-old"
            className="rounded-3xl border border-[#2A2E3D] bg-[#0F1117] p-8 md:p-10"
          >
            <div className="flex items-center justify-between mb-8">
              <h3 className="font-editorial text-3xl text-[#9CA3AF]">Old stack</h3>
              <span className="text-[10px] uppercase tracking-[0.3em] text-[#4B5563]">
                Status quo
              </span>
            </div>
            <ul className="space-y-5">
              {oldStack.map((it) => (
                <li
                  key={it}
                  className="flex items-start gap-3 text-[#9CA3AF] leading-relaxed"
                >
                  <X className="w-5 h-5 mt-0.5 text-[#4B5563] flex-shrink-0" />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Prospectivly */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            data-testid="comparison-ours"
            className="relative rounded-3xl border border-[#FF4500]/50 bg-gradient-to-b from-[#151821] to-[#0F1117] p-8 md:p-10 shadow-[0_0_60px_-20px_rgba(255,69,0,0.4)]"
          >
            <div className="absolute inset-0 rounded-3xl pointer-events-none"
              style={{
                background:
                  "radial-gradient(600px circle at 80% 0%, rgba(255,69,0,0.10), transparent 60%)",
              }}
            />
            <div className="relative flex items-center justify-between mb-8">
              <h3 className="font-editorial text-3xl text-[#EDEDED]">
                <span className="italic">prospectivly</span>
              </h3>
              <span className="text-[10px] uppercase tracking-[0.3em] text-[#FF4500]">
                The new engine
              </span>
            </div>
            <ul className="relative space-y-5">
              {ours.map((it) => (
                <li
                  key={it}
                  className="flex items-start gap-3 text-[#EDEDED] leading-relaxed"
                >
                  <Check className="w-5 h-5 mt-0.5 text-[#FF4500] flex-shrink-0" />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
